import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import FIELDS from '../data/fields';
import InputComponent from '../components/elements/input';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';
import HeaderComponent from '../components/table/header/headerComponent';
import DropZoneComponent from '../components/dropzone';
import TextArea from '../components/elements/textArea';
import AccessProfilesAction from '../app/store/actions/accessProfiles';
import VALIDATOR from '../helpers/validator/formValidator';

import randomPassword from '../helpers/generator';

// const helper = '';
class AccessProfilesForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      profile: '',
      description: '',
      message: '',
      success: '',
      active: true,      
      isUpdate: false,
      loadImage: false,
      menuItens: []
    };
  }

  async componentDidMount() {
    if (this.props.location.search) {
      const { search } = this.props.location;
      const splited = search.split('=');
      const id = splited[1];
      await this.props.getAccessProfile(id);
      const {
        description, profile, active, menuItens
      } = this.props.accessProfile;
      await this.setState({
        id, description, profile, active, isUpdate: true, menuItens
      });
    }
  }

  goBack = () => {
    history.push(ROUTES.ACCESS_PROFILE);
  } 

  createAccessProfile = async () => {
    const {
      profile, description
    } = this.state;

    const valid = VALIDATOR.accessProfileValidator({ profile, description });
    if (valid.success) {
      await this.props.createAccessProfile({
        profile, description, code: "", active: true,
      });
      await this.setState({
        message: '',
        success: I18n.t('accessProfileCreated'),
        id: '',
        profile: '',
        description: '',
        active: true,
      });
      this.goBack();
    } else {
      await this.setState({ message: valid.message, success: '' });
    }

  }

  checkAll = async () => {
    const {
      menuItens
    } = this.state;
    this.checkedRecursive(menuItens, null, true);
    await this.setState({menuItens: menuItens});
  }

  uncheckAll = async () => {
    const {
      menuItens
    } = this.state;
    this.checkedRecursive(menuItens, null, false);
    await this.setState({menuItens: menuItens});
  }

  checkedMenu = async (id, checked) => {
    const {
      menuItens
    } = this.state;

    menuItens.forEach(menuItem => {            
      if (id == menuItem.id) {
        menuItem.checked = checked;
        if (menuItem.menuItens) {          
          this.checkedRecursive(menuItem.menuItens, null, checked)
        }
      }
      else {
        if (menuItem.menuItens) {
          this.checkedRecursive(menuItem.menuItens, id, checked)
        }
      }    
    });
    await this.setState({menuItens: menuItens});

  }

  checkedRecursive = async (menuItens, id, checked) => {    
   
    menuItens.forEach(menuItem => {
      if (id == menuItem.id) {
        menuItem.checked = checked;
        if (menuItem.menuItens) {
          this.checkedRecursive(menuItem.menuItens, null, checked)
        }
      } else {
        if (!id)
          menuItem.checked = checked;
        if (menuItem.menuItens) {
          this.checkedRecursive(menuItem.menuItens, id, checked)
        }
      }
    });
  }

    

  updateAccessProfile = async () => {
    const {
      id,
      menuItens,
    } = this.state;

    
    var map = function(menuItensParam, codeArr) {
      if (!codeArr) codeArr = [];
      menuItensParam.forEach(menuItem => {
        if (menuItem.checked) codeArr.push(menuItem.id);
        if (menuItem.menuItens) {
          map(menuItem.menuItens,codeArr);
        }
      });
      return codeArr;
    }

    var code = map(menuItens).join(',');
    
    await this.props.updateAccessProfile({
      code, id,
    });
    await this.setState({ message: '', success: I18n.t('accessProfileUpdated') });
    
  }
  
  getMenuItensAux = (menuItens, level) => menuItens.map(menuItem => (
    <div key={menuItem.id}>
      <div className="width-100p main-profile-page" style={{'marginLeft': ((level * 3) - 3) + '%', 'width': (100 - (level * 3) - 3) + '%'}}>
        
                  
          <input
            onChange={e => this.checkedMenu(menuItem.id, !menuItem.checked)}
            type="checkbox"
            className="form-check-input"
            checked={!!menuItem.checked}
            id="exampleCheck1"
          />

          <button
            onClick={() => this.showMenuItem(`main${menuItem.id}`)}
            type="button"
            className="btn-not-styled cursor-pointer"
          >
            {menuItem.menuItens && menuItem.menuItens.length > 0 && <i className="fas fa-plus" /> }
            {`${menuItem.name}`}
          </button>
        
      </div>

      <div id={`main${menuItem.id}`}  style={{display: 'block'}}>        
        {menuItem.menuItens && this.getMenuItensAux(menuItem.menuItens, level + 1)}
      </div>
    </div>
  ))

  showMenuItem = async (id) => {
    const div = await document.getElementById(id);
    const style = await div.style.display;
    if (style && style === 'none') {
      div.style.display = 'block';
    } else if (style && style === 'block') {
      div.style.display = 'none';
    } else {
      document.getElementById(id).style.display = 'block';
    }
  }

  render() {
    const {
      profile,
      description,
      id,
      message,
      success,
      loadImage,
      isUpdate,
      file,
      comming,
      parentComming,
      menuItens
    } = this.state;

    return (
      <div className="main-table">
        <HeaderComponent
          title={I18n.t('accessProfileRegister')}
        />

          {menuItens && this.getMenuItensAux(menuItens, 1)}
          
        
        <div className="form-group search-custom-input">

          <button
            type="button"
            onClick={this.checkAll}
            className="btn btn-success margin-right-15"
          >
            <i className="fas fa-check-square" /> <Translate value="checkAll" />
          </button>
          <button
            type="button"
            onClick={this.uncheckAll}
            className="btn btn-danger margin-right-15"
          >
            <i className="fas fa-square" /> <Translate value="uncheckAll" />
          </button>

          <button
            type="button"
            onClick={this.goBack}
            className="btn btn-warning margin-right-15"
          >
            <Translate value="return" />
          </button>          
          {id
            ? (
              <button
                type="button"
                className="btn btn-dark margin-right-15"
                onClick={this.updateAccessProfile}
              >
                <Translate value="update" />
              </button>
            )
            : (
              <button
                type="button"
                className="btn btn-dark"
                onClick={this.createAccessProfile}
              >
                <Translate value="register" />
              </button>
            )
          }          

          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAccessProfile: id => dispatch(AccessProfilesAction.getAccessProfile(id)),
  getAccessProfileTree: id => dispatch(AccessProfilesAction.getAccessProfileTree(id)),
  updateAccessProfile: accessProfile => dispatch(AccessProfilesAction.updateAccessProfile(accessProfile)),
  createAccessProfile: accessProfile => dispatch(AccessProfilesAction.createAccessProfile(accessProfile)),
});

const mapStateToProps = state => ({
  accessProfile: state.accessProfiles && state.accessProfiles.accessProfile,
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessProfilesForm);
